export default __webpack_public_path__ + "static/media/Aiko_Icon.26cf145f.png";